import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Tabs, Tab, Dialog, DialogTitle, DialogContent, IconButton } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import t from "../../../languages/pl";
import ChangePassword from './ChangePassword';
import UserDetails from "./UserDetails";

const useStyles = theme => ({
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1)
    },
});

const UserDialog = ({classes, open, onClose, username, onUsernameChange, onPasswordChange}) => {
    const [tab, setTab] = useState(0);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                {t.userAccount}
                <IconButton
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Tabs
                    centered
                    value={tab}
                    onChange={(e, newValue) => setTab(newValue)}
                    indicatorColor="primary"
                >
                    <Tab label={t.user} value={0} index={0} />
                    <Tab label={t.passwordLabel} value={1} index={1} />
                </Tabs>
                {tab === 0 && <UserDetails username={username} onSubmit={onUsernameChange} />}
                {tab === 1 && <ChangePassword onSubmit={onPasswordChange} />}
            </DialogContent>
        </Dialog>
    );
};

UserDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    username: PropTypes.string,
    onUsernameChange: PropTypes.func,
    onPasswordChange: PropTypes.func,
};

export default withStyles(useStyles)(UserDialog);
